import { StatTableCellProps } from "components/StatsTable/StatTableColumn";
import { StatTableTextColumn } from "./TextColumn";
import { StatCell, Stat } from "../styles";

interface Props<T> extends StatTableCellProps<T, StatTableTextColumn<T>> {}

export function StatTableTextCell<T>({
  stats,
  column,
  columnIdx,
  frozenOffset,
}: Props<T>) {
  const text = column.textGetter(stats);
  return (
    <StatCell
      key={`${columnIdx} text ${text}`}
      highlight={column.highlight}
      frozenWidth={column.frozenWidth}
      frozenOffset={frozenOffset}
      border={column.border}
    >
      <Stat>{text}</Stat>
    </StatCell>
  );
}
